export type ObjectWithAnyValues = { [key: string]: any };
export type WithUnknownFields<T> = T & Record<string, unknown>;

export type Tab = {
	title: string;
	baseUrl: string;
	isNecessaryTenant: boolean;
	BaseListComponent?: () => JSX.Element;
	BaseDetailsComponent?: () => JSX.Element;
	BaseCreateComponent?: () => JSX.Element;
	BaseEditComponent?: () => JSX.Element;
};

export enum Tabs {
	TENANTS = "tenants",
	PARTNERS = "partners",
	CUSTOMERS = "customers"
}
